import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip, useTheme } from "@mui/material";

// Types
import { IButtonGroupControl, PickerItem } from "@/@types/controls/controls";
import { PickerItemValue } from "@/@types/models/model";

function ButtonGroupControl(props: IButtonGroupControl) {
  const { dc, field, value, onChange } = props;
  const { rowWidth = 4 } = field;
  const { t } = useTranslation();
  const theme = useTheme();

  const [items, setItems] = useState<Array<PickerItem>>([]);

  useEffect(() => {
    getItems();
  }, []);

  const handleChange = (val: PickerItemValue) => {
    const item = getItem(val);

    if (onChange) {
      if (item !== undefined) {
        if (item && value && (item.value === value || item.value === (value as PickerItem).value)) {
          onChange(null, field.source);
        } else {
          onChange(item, field.source);
        }
      } else {
        onChange(null, field.source);
      }
    }
  };

  const getItems = () => {
    if (field && field.hasOwnProperty("subModel") && dc) {
      dc.GetData().then((data) => {
        if (Array.isArray(data)) {
          setItems(data as Array<PickerItem>);
        } else {
          setItems([]);
        }
      });
    } else if (field && field.items) {
      let items: PickerItem[] = [];
      field.items.labels.forEach((label, i) => {
        const v = field.items?.values[i];
        if (v !== undefined && v !== null) {
          items.push({ label: t(label), value: v });
        }
      });
      setItems(items);
    } else {
      setItems([]);
    }
  };

  const getItem = (value: PickerItemValue) => {
    switch (typeof value) {
      case "string":
        let item = items.find((x) => x.value === value)
        if (item === undefined) {
          item = items.find((x) => x.value === parseInt(value, 10));
        }
        return item;
      case "number":
      case "boolean":
        return items.find((x) => x.value === value);
      default:
        return undefined;
    }
  };

  const getDefaultItem = () => {
    // if (field && field.subModel && field.subModel.name && dc) {
    //   defaultValue = dc.defaultItem;
    // }
    if (field && field.items && field.items.hasOwnProperty("default")) {
      const defaultValue = field.items.default;
      if (defaultValue !== undefined) {
        const item = getItem(defaultValue);
        return item;
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }

  };

  const getKey = () => {
    return Math.floor(Math.random() * 1_000_000_000);
  }

  const val = value && typeof value === 'object' && ('value' in value) ? value.value : value;
  const radioKey = `${getKey()}-${getKey()}-${getKey()}-${getKey()}`;
  return (
    items.length ?
      <div>
        {
          Array(Math.max(items.length / rowWidth, 1)).fill(0).map((_, i) => (
            <div style={{
              minWidth: `${rowWidth * 22}px`, /*20px btn width + border 1px on each side*/
              width: `${rowWidth * 22}px`,
              height: '20px'
            }}>
              {
                items.slice(i * rowWidth, (i + 1) * rowWidth).map((item, j) => {
                  return (
                    <Tooltip title={t("tooltips." + field.source + "." + item.label) as string}>
                      <span
                        style={{
                          // margin: "1px",
                          border: `1px solid ${theme.palette.primary.main}`,
                          borderRadius: '2px',
                          backgroundColor: item.value === val ? theme.palette.primary.main : "#fff",
                          color: item.value === val ? "#fff" : "#000",
                          textAlign: "center",
                          display: "block",
                          float: "left",
                          width: "20px",
                          height: "20px"
                        }}
                      >
                        <label
                          htmlFor={`${radioKey}-${i}-${j}`}
                          onClick={(evt) => {
                            if (!onChange) {
                              //@ts-ignore
                              window.__GlobalState['button-group-ctrl'] = { ...item };
                            }
                          }}
                          style={{
                            display: "block",
                            width: "18px",
                            height: "20px",
                            cursor: "pointer"
                          }}
                        >
                          {t(item.label)}
                        </label>
                        <input
                          type="radio"
                          // @ts-ignore
                          id={`${radioKey}-${i}-${j}`}
                          onClick={(evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                            handleChange(item.value)
                          }
                          }
                          style={{
                            visibility: "hidden",
                            display: "block",
                            width: "20px",
                            height: "20px",
                            marginTop: "-20px",
                            cursor: "pointer",
                          }}
                        // value={val ? val : undefined}
                        />
                      </span>
                    </Tooltip>
                  )
                })
              }
            </div>
          ))
        }
      </div >
      : null
  )
}

export default ButtonGroupControl;